import { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, Grid, TextField } from '@mui/material';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterTrackShippingProps {
  onSubmit: () => void;
  cpeId: string;
  shippingTrackNumber: string;
}

export const RouterTrackShipping = (
  { onSubmit, cpeId, shippingTrackNumber }: RouterTrackShippingProps,
) => {
  const api = useApi();
  const [newShippingTrackNumber, setNewShippingTrackNumber] = useState<string>(shippingTrackNumber);
  const [imei, setImei] = useState<string>('');
  const [iccid, setIccid] = useState<string>('');

  const shippingTrackInfoUpdate = useMutation(
    api.updateCpeShippingInfoApiV1UpdateCpeShippingInfoPost,
    {
      onSuccess() {
        toast.success('Updated shipping track number successfully.');
        onSubmit();
      },
      onError: apiError,
    },
  );

  const handleSubmit = () => {
    shippingTrackInfoUpdate.mutate({
      cpe_id: cpeId,
      tracking_number: newShippingTrackNumber,
      ...(imei && { imei }),
      ...(iccid && { iccid }),
    });
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Shipping Track Number"
        variant="outlined"
        value={newShippingTrackNumber}
        onChange={(e) => setNewShippingTrackNumber(e.target.value)}
        autoFocus
      />
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="IMEI"
            variant="outlined"
            value={imei}
            onChange={(e) => setImei(e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="ICCID"
            variant="outlined"
            value={iccid}
            onChange={(e) => setIccid(e.target.value)}
          />
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
